import { actions } from './Reducer';

export const getSupplierPrivateInquiryAction = payload => ({
  type: actions.GET_SUPPLIER_PRIVATE_INQUIREY,
  payload
});

export const getSupplierPrivateInquiriesAction = payload => ({
  type: actions.GET_SUPPLIER_PRIVATE_INQUIRIES,
  payload
});

export const getSupplierPrivateInquirySuccessAction = privateInquiry => ({
  type: actions.GET_SUPPLIER_PRIVATE_INQUIREY_SUCCESS,
  payload: privateInquiry
});

export const getSupplierPrivateInquiriesSuccessAction = privateInquiries => ({
  type: actions.GET_SUPPLIER_PRIVATE_INQUIRIES_SUCCESS,
  payload: privateInquiries
});

export const getSupplierPrivateStagingInquiriesAction = staging => ({
  type: actions.GET_SUPPLIER_PRIVATE_STAGING_INQUIRIES,
  payload: staging
});
export const getSupplierPrivateStagingInquiriesSuccessAction = staging => ({
  type: actions.GET_SUPPLIER_PRIVATE_STAGING_INQUIRIES_SUCCESS,
  payload: staging
});

export const setSupplierPrivateInquiryIsLoading = isLoading => ({
  type: actions.SUPPLIER_PRIVATE_INQUIREY_IS_LOADING,
  payload: isLoading
});

export const deleteSupplierPrivateInquiryAction = (id, url) => {
  console.log(id,url, 'deletee');
  return {
    type: actions.DELETE_PRIVATE_SUPPLIER_INQUIRY,
    payload: {id,url}
  };
};

export const deleteSupplierPrivateInquirySuccessAction = id => ({
  type: actions.DELETE_PRIVATE_SUPPLIER_INQUIRY_SUCCESS,
  payload: id
});

export const editSupplierPrivateInquiryAction = (id, body) => {
  console.log(id, body);
  return {
    type: actions.EDIT_PRIVATE_SUPPLIER_INQUIRY,
    payload: {
      id,
      body
    }
  };
};

export const editSupplierPrivateInquirySuccessAction = inquiry => ({
  type: actions.EDIT_PRIVATE_SUPPLIER_INQUIRY_SUCCESS,
  payload: inquiry
});

export const addSupplierPrivateInquiryAction = body => ({
  type: actions.ADD_PRIVATE_SUPPLIER_INQUIRY,
  payload: body
});

export const addSupplierPrivateInquirySuccessAction = inquiry => ({
  type: actions.ADD_PRIVATE_SUPPLIER_INQUIRY_SUCCESS,
  payload: inquiry
});

export const setPrivateSupplierInquiryAction = count => ({
  type: actions.SET_PRIVATE_SUPPLIER_INQUIRY_COUNT,
  payload: count
});
